













































import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    methods: {
        ...mapActions('bh-roles', { findRole: 'find' }),
        ...mapActions('bh-quest-routin', { addQuestRoutin: 'create' })
    },
    components: {
        
    }
})
export default class QuestListsTable extends Vue {
    @Prop({ default() { return null; } })
    item!: any;

    @Prop({ default: null })
    type!: string;

    @Prop({ default: null })
    routin!: string;

    dialogAdd = false;
    dialogLoading = false;

    findRole: any;
    addQuestRoutin: any;

    form = {
        name: this.item ? this.item.name : null,
        quest_hook: this.item ? {
            id: this.item.quest_hook_id,
            atomic_action: '(Unchanged)'
        } : null,
        max: this.item ? this.item.max : null,
        logic_control: this.item ? this.item.logic_control : null
    };

    public valueComparison(a: any, b: any) {
        return a === b;
    }

    public async addQuest() {
        this.dialogLoading = true;
        try {
            let roleId = null;
            if(this.type) {
                await this.findRole({
                    query: { name: this.type.toLowerCase() }
                }).then((items: any) => {
                    if(items.data.length !== 0 && items.total === 1) {
                        roleId = items.data[0].id;
                    }
                });
            }
            if(!this.form.quest_hook) {
                throw new Error('Invalid quest hook!');
            }
            if(this.item) {
                this.item.name = this.form.name;
                this.item.quest_hook_id = (this.form.quest_hook || { id: null }).id;
                this.item.max = this.form.max;
                this.item.logic_control = this.form.logic_control;
                await this.item.patch();
            } else {
                await this.addQuestRoutin({
                    name: this.form.name,
                    role_id: roleId,
                    quest_hook_id: (this.form.quest_hook || { id: null }).id,
                    max: this.form.max,
                    type: this.routin
                });
                this.form.name = null;
                this.form.quest_hook = null;
                this.form.max = null;
                this.form.logic_control = null;
            }
            this.dialogAdd = false;
        } catch(err) {
            console.log(err);
        } finally {
            this.dialogLoading = false;
        }
        // console.log('test');
    }
}
